import * as React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { DeveloperNavigationPath } from "src/common/developers";
import { DeveloperWrapper } from "./";
import { CreateUser, Info, Organization } from "./workflow";

function Workflows() {
  return (
    <DeveloperWrapper type={DeveloperNavigationPath.WorkflowNavigation}>
      <Routes>
        <Route path="/" element={<Navigate to="info" replace />} />
        <Route path="/info" element={<Info />} />
        <Route path="/create-user" element={<CreateUser />} />
        <Route path="/organization" element={<Organization />} />
      </Routes>
    </DeveloperWrapper>
  );
}

export default React.memo(Workflows);
